module.exports = __webpack_public_path__ + "static/img/2in house canary.78483b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/2in house canary.jpg
// module id = IrSy
// module chunks = 1